import type { BranchNodeData, FilterNodeData } from 'app/types/workflows'
import { type Panel, useConditionValueOptions } from './panelShared'
import { ConditionEditor } from './ConditionEditor'
import { Section } from './Section'

export function FilterPanel({
  data,
  set,
  errors,
  availableFields,
}: Panel<FilterNodeData> & { availableFields: string[] }) {
  const valueOptions = useConditionValueOptions(availableFields)
  return (
    <>
      <Section title="Continue when">
        <ConditionEditor
          match={data.match}
          conditions={data.conditions}
          onChange={set}
          availableFields={availableFields}
          valueOptions={valueOptions}
          error={errors.conditions}
          label={null}
        />
        <div className="text-[11px] text-subtle">Anyone who doesn't match leaves the workflow here.</div>
      </Section>
    </>
  )
}

export function BranchPanel({
  data,
  set,
  errors,
  availableFields,
}: Panel<BranchNodeData> & { availableFields: string[] }) {
  const valueOptions = useConditionValueOptions(availableFields)
  return (
    <>
      <Section title="Yes when">
        <ConditionEditor
          match={data.match}
          conditions={data.conditions}
          onChange={set}
          availableFields={availableFields}
          valueOptions={valueOptions}
          error={errors.conditions}
          label={null}
        />
        <div className="text-[11px] text-subtle">Everyone else takes the No path.</div>
      </Section>
    </>
  )
}

export function ExitPanel() {
  return (
    <Section>
      <div className="text-xs text-subtle">The contact leaves the workflow here. No further steps run.</div>
    </Section>
  )
}
